/* import __COLOCATED_TEMPLATE__ from './posting-create-initial-message.hbs'; */
import Component from '@glimmer/component';
import { action, get, set } from '@ember/object';
import { inject as service } from '@ember/service';

const CLASS_NAME = 'SH-c-posting-create-initial-message';

class PostingCreateInitialMessage extends Component {
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;

  get className() {
    return CLASS_NAME;
  }

  get areFormElementsDisabled() {
    return this.state.areFormElementsDisabled;
  }

  get errors() {
    return get(this.state, 'errors');
  }

  @action
  handleMessageInput(text) {
    set(this.state, 'errors', {
      ...this.errors,
      description: undefined,
      message: undefined,
    });

    this.stateManager.setDirectFreelancerMessage(text);
  }
}

export default PostingCreateInitialMessage;
